import { render, staticRenderFns } from "./EmbedQuiz.vue?vue&type=template&id=69ddb9bc&"
import script from "./EmbedQuiz.vue?vue&type=script&lang=js&"
export * from "./EmbedQuiz.vue?vue&type=script&lang=js&"
import style0 from "./EmbedQuiz.vue?vue&type=style&index=0&id=69ddb9bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports